import './style.scss';

import React from 'react';
import { useDebounce } from 'react-use';

import { useResizeObserver } from 'hooks/utility';
import { useTypedDispatch } from 'store';
import { setLayoutWidth } from 'store/slices/ui';

interface IApplicationContentProps {
  children?: React.ReactNode;
}

const ApplicationContent: React.FC<IApplicationContentProps> = ({ children }) => {
  const dispatch = useTypedDispatch();
  const [resizableRef, sizes] = useResizeObserver();

  useDebounce(
    () => {
      // remove paddings and margins
      dispatch(setLayoutWidth(sizes.width));
    },
    200,
    [sizes],
  );

  return (
    <main ref={resizableRef} className="mm-application-layout__content">
      {children}
    </main>
  );
};

export { ApplicationContent };
